module.exports = __webpack_public_path__ + "static/media/img-01.0a25cbb7.jpg";